// extracted by mini-css-extract-plugin
export default {"container":"styles_container__KFIhn","btnStyle":"styles_btnStyle__SzRM6"};